module.exports = __webpack_public_path__ + "_assets/img/coin-icon.6deaa7de.svg";